// Automatically determines the fastest API base URL
// In production in the browser (Hostinger): uses relative path '' (no cross-origin overhead, no preflight OPTIONS request, works on both subifyhub.com and www.subifyhub.com)
// In local development (localhost): uses REACT_APP_API_URL or http://localhost:5000
export const getApiUrl = () => {
  if (
    typeof window !== 'undefined' &&
    window.location.hostname &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'
  ) {
    return '';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5000';
};

export const API_URL = getApiUrl();
